export default __webpack_public_path__ + "static/media/icons-cost-code-black.ae8b018a.svg";